import React from 'react';
import Input from '../../../shared/forms/Input';
import { ReactComponent as EyeOpenIcon } from '../../../assets/icons/eye-open.svg';
import { ReactComponent as EyeClosedIcon } from '../../../assets/icons/eye-closed.svg';

const ProfilePasswordInput = ({label, target, onChange, value, disabled = false, className = ''}) => {
  let [show, setShow] = React.useState(false);
  let [warning, setWarning] = React.useState(null);

  let icon = disabled ? null : (
    show ?
      <EyeClosedIcon className='icon sm action-icon eye-icon'
                     onClick={() => setShow(!show)}/> :
    <EyeOpenIcon className='icon sm action-icon eye-icon'
                 onClick={() => setShow(!show)}/>
  );

  return (
    <div className={`password-input${className ? ` ${className}` : ''}`}>
      <Input label={label}
             type={show ? 'text' : 'password'}
             icon={icon}
             value={value}
             disabled={disabled}
             borderColor={warning ? 'var(--warning)' : null}
             onChange={(e) => {
               if (disabled) return;
               if (e.target.value.length < 8) {
                 setWarning('Password is less than 8 characters');
               }
               else if (!e.target.value.match(/[A-Z]/)) {
                 setWarning('Password does not contain an uppercase letter');
               }
               else if (!e.target.value.match(/[0-9]/)) {
                 setWarning('Password does not contain a number');
               }
               else if (target && e.target.value !== target) {
                 setWarning('Passwords do not match');
               }
               else {
                 setWarning(null);
               }

               if (onChange) {
                 onChange(e);
               }
             }}
      />
      {!disabled && warning && (
        <span className="password-input__warning">
          {warning}
        </span>
      )}
    </div>
  );
}

export default ProfilePasswordInput;
